import React from 'react'
import { motion } from "framer-motion"
import about_bg from "../../../assets/images/about/about-6.png"
import { slideUp } from '../../../utlits/slideUp'
const AboutTwo = () => {
  return (
    <div className="about-area pb-75">
      <div className="container">
        <div className="row align-items-center" data-cue="slideInUp">
          <div className="col-lg-8">
            <motion.div className="about-content style-3"
              initial="offscreen"
              whileInView="onscreen"
              variants={slideUp(1)}
              viewport={{ once: true, amount: 0.4 }}
            >
              <div className="title">
                <span className="d-block">Proud Partner</span>
                <h2>S.P.S CPR LLC</h2>
                <p>We have teamed up with SPS CPR to better serve our customers, with a combination of over 35 years of service in public safety through a wide variety of positions. We are here to offer our services teaching security solutions, safety awareness, injury prevention, injury response, and leadership development. We want to see your business or organization thrive and grow.</p>
              </div>
              <div className="row">
                <div className="col-lg-6 col-sm-6">
                  <div className="content-item">
                    <h3>Our Commitment</h3>
                    <p>Partnering with SPS CPR reflects our unwavering commitment to delivering the highest quality CPR training. We believe that life-saving skills and knowledge should be accessible to everyone, and we are dedicated to turning that belief into reality.</p>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6">
                  <div className="content-item">
                    <h3>Convenient Training</h3>
                    <p>We offer in-person training options to make it convenient for you to learn CPR. Our in-person classes are held at our training facility, and we also offer on-site training for groups. </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
          <div className="col-lg-4">
            <motion.div className="about-image style-3"
              initial="offscreen"
              whileInView="onscreen"
              variants={slideUp(2)}
              viewport={{ once: true, amount: 0.4 }}
            >
              <img src={about_bg} alt="about-image" />
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutTwo